import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dataServiceBaseUrl, dataService } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const allAgentMasterService = createApi({
  reducerPath: "allAgentMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: dataServiceBaseUrl }),
  tagTypes: ["allAgentMaster"],
  endpoints: (builder) => ({
    getAllAgentMasterWithPagination: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.getAllAgentMasterWithPagination}?page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getAllAgentMasterWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.getAllAgentMasterWithSearch}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateAgentMaster: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.updateAgentMaster}/${body.id}`,
          method: "PUT",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteAgentMasterById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.deleteAgentMasterById}/${body.id}`,
          method: "DELETE",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAgentMasterById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.getAgentMasterById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveAgentMaster: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.saveAgentMaster}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
     getAgentMastersAgentMastersetIdById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.getAgentMasterById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAllAgentMaster: builder.mutation({
      query(body) {
        return {
          url: `${dataService.agentMasterController.getAllAgentMaster}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
  }),
});
export const {
  useGetAllAgentMasterWithPaginationMutation,
  useSaveAgentMasterMutation,
  useDeleteAgentMasterByIdMutation,
  useGetAgentMasterByIdMutation,
  useUpdateAgentMasterMutation,
  useGetAllAgentMasterWithSearchMutation,
  useGetAllAgentMasterMutation
} = allAgentMasterService;
